import type {IImmutableComponent} from '@gl/lit/components/mixins/immutable_component/index.js';
import type {VariantAtom} from '@gl/lit/types/architecture.js';
import {CanvasElementEventAction} from '@gl/lit/components/base/canvas_element/index.js';

/**
 * Immutable cmd for dispatching an cavnas element's moved event.
 */
export function dispatchMovedEvent<
  Model,
  Msg extends VariantAtom<string>,
  T extends IImmutableComponent<Model, Msg> | Element,
>(element: T) {
  element.dispatchEvent(new CustomEvent(CanvasElementEventAction.Moved));
}
